const yellowAnimation = ($animations) => {
    if (!$animations) {
        $animations = $(".animations");
    }
  //  console.log(`animations length:`, $animations.length)
    $animations.each(function () {
        const style = $(this).data("animation") || "text";
        const width = $(this).width();
        const height = $(this).height();
        const fontSize = Number($(this).css('font-size').replace(/px/g, "")) || 0;
        const speed = $(this).data("speed");
        const autoplay = $(this).data("autoplay") || true;
        let baseSize = Math.min(width, height);

        if (style == "text") {
            baseSize = fontSize
        }
        if (baseSize == 0) {
            setTimeout(() => {
         //       console.log("reload")
                yellowAnimation($(this));
            }, 500);
        }
        let iconSize = $(this).data("size") * baseSize || baseSize * 2.5;


        let $icon = $(this).find(".yellow-circle");
        if (!$icon.length) {
            $(this).append("<div class='yellow-circle'></div>");
            $icon = $(this).find(".yellow-circle");
        }
        //remove old animation
        if ($(this).data("anime")) {
            $(this).data("anime").reset();
            $(this).data("anime").pause()
            $(this).data("anime").remove($icon[0]);
        }

        $icon.css({
            width: iconSize,
            height: iconSize,
            top: - ((iconSize - fontSize) / 2),
            left: - ((iconSize - fontSize) / 2),
        })

        let option = {
            targets: $icon[0],
            // translateX: function () {
            //     return anime.random(200, 270);
            // },
            direction: 'alternate',
            easing: 'cubicBezier(.5, .05, .1, .3)',
            duration: speed || 1500,
            loop: true,
            autoplay: autoplay
            //  complete: randomValues
        }
        switch (style) {
            case 'text':
                $icon.css({
                    'z-index': -1
                })
                option["translateX"] = $(this).width() - iconSize / 2;
                option['duration'] = speed || anime.random(1000, 2000);
                break;
            case 'w':
                const randomXY = () => {
                    let translateX = [];
                    let translateY = [];
                    let width = $(this).width();
                    let height = $(this).height() * 0.8; //chỉ cho vòng tròn chạy tối đa 0.3 chiều cao
                    const line = 0.5 // đường line ngăn chữ w ở 50%
                    for (let i = 0; i < 5; i++) {
                        const delta = (i) % 2;
                        translateX.push(anime.random(i * 0.2 * width, (i + 1) * 0.2 * width));
                        translateY.push(anime.random(delta * height * line, height * (line + (1 - line) * delta)));

                    }
                    return {
                        translateX, translateY
                    }
                }
                const { translateX, translateY } = randomXY();
                $icon.css({
                    top: translateY[0],
                    left: translateX[0]
                });
                option['translateX'] = translateX.map(x => x - translateX[0]).slice(1);
                option['translateY'] = translateY.map(y => y - translateY[0]).slice(1)
                option['duration'] = speed || 5000;

                break;
            case 'heartbeat':
                $icon.css({
                    top: "50%",
                    left: "50%",
                    transform: `translateX(-50%) translateY(-50%)`
                });
                option["scale"] = [1.4, 1.2, 1.6]
                option["easing"] = "linear"
                option['duration'] = speed || 3000;

                break;
        }
        const animationObject = anime(option);
        $(this).data("anime", animationObject)
    })
}

const textSlideUp = () => {
    const $textSlideUp = $(".text-slide-up");
    $textSlideUp.each(function () {
        //thêm 1 phần tử 0 vào cuối để tạo hiệu ứng
        const $li = $(this).find("li");
        $(this).append($($li[0]).clone());

        const targets = $(this).find("li").toArray();
        let translateY = [];

        for (let i = 0; i < targets.length; i++) {

            translateY.push({
                value: `${-100 * i}%`,
                delay: i == 0 ? 0 : $(targets[i - 1]).data("delay") || 1000,
                duration: i == 0 ? 0 : $(targets[i]).data("speed") || 3000
            })
        }
        let animation = anime({
            targets: targets,
            translateY: translateY,
            easing: 'easeInOutQuint',
            loop: true
        });
        $textSlideUp.data("anime", animation)
    })
}
const animations = () => {
    textSlideUp();
    yellowAnimation();
    let currentWidth = $(window).width();
    $(window).on("resize", function () {
        if ($(window).width() == currentWidth) return;
        currentWidth = $(window).width();
        yellowAnimation();
    })
}

module.exports = animations